import type {VwpAuthUser} from '../store/generated/api';
import {logger} from './logger';

interface JwtPayload {
    exp?: number;
    userId?: string;
    sub?: string;
    email?: string;
    name?: string;
    first_name?: string;
    firstName?: string;
    last_name?: string;
    lastName?: string;
    roles?: string[];
}

export class TokenUtils {
    static getTokenPayload(token: string): JwtPayload | null {
        try {
            const parts = token.split('.');
            if (parts.length !== 3) {
                return null;
            }

            const payload = parts[1];
            if (!payload) {
                return null;
            }

            return JSON.parse(atob(payload)) as JwtPayload;
        } catch (error) {
            logger.error('Error decoding token payload:', error);
            return null;
        }
    }

    static createUserFromToken(token: string): VwpAuthUser | null {
        const payload = this.getTokenPayload(token);
        
        if (!payload) {
            return null;
        }

        return {
            id: payload.userId || payload.sub || '0',
            email: payload.email || payload.sub || '',
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            active: true,
            roles: payload.roles || [],
            firstName: payload.firstName,
            lastName: payload.lastName,
            avatar: undefined,
            last_login: undefined
        };
    }
}